import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Card from "react-bootstrap/Card";
import Alert from "react-bootstrap/Alert";
import { postUser } from "../actions/userAction";

class CreateUserProfile extends React.Component {
  state = {
    errors: [],
    merchant_id: 0,
    first_name: "",
    last_name: "",
    inputted_store: "",
    email: "",
    password: "",
    passwordConfirmation: "",
    show: false,
  };
  handleInputChange = this.handleInputChange.bind(this);
  handleSubmit = this.handleSubmit.bind(this);

  componentDidMount() {
    this.props;
    this.setState({
      merchant_id: this.props.merchant ? this.props.merchant.id : "",
      inputted_store: this.props.merchant ? this.props.merchant.name : "",
    });
  }
  displayErrors = (errors) =>
    errors.map((error, i) => <p key={i}>{error.message}</p>);

  isFormValid = () => {
    let errors = [];
    let error;

    if (this.isFormEmpty(this.state)) {
      error = { message: "Fill in all fields" };
      this.setState({ errors: errors.concat(error) });
      return false;
    } else if (!this.isPasswordValid(this.state)) {
      error = { message: "Password is invalid" };
      this.setState({ errors: errors.concat(error) });
      return false;
    } else if (!this.isEmailValid(this.state)) {
      error = { message: "Email address is invalid" };
      this.setState({ errors: errors.concat(error) });
      return false;
    } else {
      return true;
    }
  };
  isFormEmpty = ({
    first_name,
    last_name,
    email,
    password,
    passwordConfirmation,
  }) => {
    return (
      !first_name.length ||
      !last_name.length ||
      !email.length ||
      !password.length ||
      !passwordConfirmation.length
    );
  };
  isEmailValid = ({ email }) => {
    if (email.includes("@")) {
      return true;
    } else {
      return false;
    }
  };
  isPasswordValid = ({ password, passwordConfirmation }) => {
    if (password.length < 6 || passwordConfirmation.length < 6) {
      return false;
    } else if (password !== passwordConfirmation) {
      return false;
    } else {
      return true;
    }
  };
  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isFormValid(this.state)) {
      const formData = new FormData();
      const auth_token = document.querySelector("[name=csrf-token]").content;
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      // console.log(auth_token);
      formData.append("user[merchant_id]", this.state.merchant_id);
      formData.append("user[inputted_store]", this.state.inputted_store);
      formData.append("user[first_name]", this.state.first_name);
      formData.append("user[last_name]", this.state.last_name);
      formData.append("user[email]", this.state.email.toLowerCase());
      formData.append("user[password]", this.state.password);

      this.props.postUser(formData, config);

      // setTimeout(() => {
      //   this.setState({ show: true });
      // }, 1000);
      // window.location.replace("http://localhost:3000/api/v1/users/userview");
    }
  }

  render() {
    return (
      <div className="container">
        <style type="text/css">
          {`
    .btn-flat {
      display: inline;
      background-color: #184667;
      color: white;
      margin-bottom: 10px;
      width: 100%;
    }
    .bg-flat {
      background-color: #84cac14a;
      color: #047688;
      border-radius: 8px;
      border: 1px solid teal;
    }
    .card-deck .card  {
      margin-bottom: 10px;  
      font-size: 1.2rem;
      display: flex;
    }
    .btn-xxl {
      padding: 10px;
      font-size: 1.2rem;
    }
    `}
        </style>
        <h3 className="text-center">
          Create new Mile1 user account for {this.props.merchant.name}
        </h3>
        <br></br>

        <Form
          noValidate
          className="bg-flat container"
          onSubmit={this.handleSubmit}
        >
          <Form.Row>
            <Form.Group as={Col} controlId="formGridFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                required
                name="first_name"
                onChange={this.handleInputChange}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                required
                name="last_name"
                onChange={this.handleInputChange}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                required
                type="email"
                name="email"
                onChange={this.handleInputChange}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridPassword">
              <Form.Label>Password (at least 6 symbols)</Form.Label>
              <Form.Control
                required
                type="password"
                name="password"
                onChange={this.handleInputChange}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridPasswordConfirmation">
              <Form.Label>Password Confirmation</Form.Label>
              <Form.Control
                required
                name="passwordConfirmation"
                type="password"
                onChange={this.handleInputChange}
              />
            </Form.Group>
          </Form.Row>
          {this.state.errors.length > 0 && (
            <Alert variant={"danger"}>
              <h3>Error</h3>
              {this.displayErrors(this.state.errors)}
            </Alert>
          )}
          <ButtonGroup className="btn-flat">
            <Button className="btn-flat" variant="outline-dark" type="submit">
              Create User Account
            </Button>
          </ButtonGroup>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = ({ postMerchant }) => ({
  merchant: postMerchant.merchant,
});
const mapDispatchToProps = (dispatch) => ({
  postUser: (user) => dispatch(postUser(user)),
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateUserProfile)
);
